var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "275px",
    height: "56px",
    viewBox: "0 0 275 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fyld Logo Full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1.1-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L-1-00_Dashboard_log_in-Copy-2",
    transform: "translate(-80.000000, -148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(80.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brand/full-logo/black-background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FYLD_RGB_BBG_FULL-LOGO_COLOUR"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    fill: "#FFF308",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 56.0714286,
    height: 56
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(12.335714, 12.320000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    points: "26.9142857 43.68 33.6428571 43.68 33.6428571 33.6 43.7357143 33.6 43.7357143 26.88 33.6428571 26.88 33.6428571 20.16 43.7357143 20.16 43.7357143 13.44 26.9142857 13.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#151515",
    points: "0 43.68 6.72857143 43.68 6.72857143 6.72 13.4571429 6.72 13.4571429 43.68 20.1857143 43.68 20.1857143 6.72 43.7357143 6.72 43.7357143 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "82.9857143 33.6 89.7142857 33.6 89.7142857 20.16 103.171429 20.16 103.171429 13.44 89.7142857 13.44 89.7142857 6.72 103.171429 6.72 103.171429 0 82.9857143 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "192.885714 0 186.157143 0 186.157143 33.6 206.342857 33.6 206.342857 26.88 192.885714 26.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.835714,0 L233.257143,0 L233.257143,33.6 L247.835714,33.6 C256.470714,33.6 262.414286,25.5136 262.414286,16.8 C262.414286,8.0864 256.470714,0 247.835714,0 Z M247.835714,26.88 L239.985714,26.88 L239.985714,6.72 L247.835714,6.72 C252.388714,6.72 255.685714,11.4688 255.685714,16.8 C255.685714,22.1312 252.388714,26.88 247.835714,26.88 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "144.664286 10.3712 134.369571 0.0896 129.614714 4.8384 141.3 16.5088 141.3 33.6 148.028571 33.6 148.028571 16.5088 159.713857 4.8384 154.959 0.0896"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.96b275738bd5ced089b626d67d1dc469.svg";
export { ForwardRef as ReactComponent };